import React from 'react';
import { useSelector } from 'react-redux';

import { useActions } from '@src/containers/Map/hooks';
import getMappedSpaces from '@src/containers/SpacesListing/selectors/getMappedSpaces';
import useHandleClickLike from '@src/containers/Session/hooks/useHandleClickLike';
import useFiltersReset from '@src/containers/Filters/hooks/useResetFilters';
import AdvertCDefault from '@src/components/Advert/connectors/default';

import CardsGrid from '..';

const CardsGridCSpaces = () => {
	const items = useSelector(getMappedSpaces);
	const handleClickLike = useHandleClickLike();
	const { openMapInListing } = useActions();
	const { handleFiltersReset } = useFiltersReset();

	const handleMapClick = React.useCallback(
		({ id }) => {
			const target = items.find((c) => c.id === id);
			openMapInListing({ id: `_${id}_`, coords: target.coordinate });
		},
		[openMapInListing, items],
	);

	return (
		<CardsGrid
			adaptive="spaces"
			items={items}
			adv={items.length ? <AdvertCDefault /> : undefined}
			onClickLike={handleClickLike}
			onClickMap={handleMapClick}
			onResetClick={handleFiltersReset}
		/>
	);
};

export default CardsGridCSpaces;
